import { CancellationMode, ReceiptType } from "@/data/model/Enums";
import { exceptionTypes, role } from "@/data/util/Config";

import { CancellationPositionsWindow } from "@/components/dialog/CancellationPositionsWindow";
import { CancellationWindow } from "@/components/dialog/CancellationWindow";

import { PrintReceiptWindow } from "@/portal/modal/PrintReceiptWindow";
import { ReprintOrderModal } from "@/portal/modal/ReprintOrderModal";
import { SendOrderReceiptWindow } from "@/portal/modal/SendOrderReceiptWindow";
import { isInRole } from "@/portal/Trans";

export class OrderController {
    private $element: JQuery;
    private orderId: string;
    private isPayLater: boolean;

    constructor(element: JQuery) {
        this.$element = element;
        this.orderId = this.$element.attr("data-id");
        this.isPayLater = this.$element.attr("data-is-pay-later") == "1";

        this.$element.find("#reprintbtn").click((e) => {
            e.preventDefault();
            this.openReprint();

            return false;
        });

        this.$element.find("#cancellationactions .dropdown-menu > .dropdown-item").click((e) => {
            e.preventDefault();

            let mode: CancellationMode;
            switch ($(e.currentTarget).attr("data-action")) {
                case "wholeorder":
                    mode = CancellationMode.WholeOrder;
                    break;
                case "amount":
                    mode = CancellationMode.Amount;
                    break;
                case "positions":
                    mode = CancellationMode.Positions;
                    break;
            }

            this.openCancellation(this.isPayLater, mode!);
        });

        this.$element.find("#receiptactions .dropdown-menu > .dropdown-item").click((e) => {
            e.preventDefault();

            switch ($(e.currentTarget).attr("data-action")) {
                case "sendreceipt":
                    this.openSendReceipt();
                    break;
                case "printreceipt":
                    this.openPrintReceipt();
                    break;
            }
        });

        //bind failed payment collapse
        const failedTransactionContainer = this.$element.find(".failedtransactions");
        if (failedTransactionContainer.length > 0) {
            failedTransactionContainer.find("> .head").click(() => {
                if (failedTransactionContainer.hasClass("open"))
                    failedTransactionContainer
                        .removeClass("open")
                        .find("> .inner")
                        .stop(true, false)
                        .slideUp(300, "easeOutExpo");
                else
                    failedTransactionContainer
                        .addClass("open")
                        .find("> .inner")
                        .stop(true, false)
                        .slideDown(300, "easeOutExpo");
            });
        }
    }

    public openReprint(productionSite?: string) {
        const m = new ReprintOrderModal(this.orderId, productionSite);
        m.show();
    }

    public openSendReceipt() {
        const m = new SendOrderReceiptWindow(this.orderId, ReceiptType.Order, undefined);
        m.show();
    }

    private openPrintReceipt() {
        const m = new PrintReceiptWindow(this.orderId, ReceiptType.Order, undefined);
        m.show();
    }

    public openCancellation(payLater: boolean, mode: CancellationMode) {
        if (payLater && mode == CancellationMode.Positions) {
            const m = new CancellationPositionsWindow(
                this.orderId,
                isInRole(role.Admin),
                false,
                () => {
                    location.reload();
                },
                (errorCode: string) => {
                    if (errorCode !== exceptionTypes.cancellationNotAllowedForPayment) {
                        location.reload();
                    }
                }
            );
            m.show();
        } else {
            const m = new CancellationWindow(
                this.orderId,
                isInRole(role.Admin),
                false,
                mode,
                () => {
                    location.reload();
                },
                (errorCode: string) => {
                    if (errorCode !== exceptionTypes.cancellationNotAllowedForPayment) {
                        location.reload();
                    }
                }
            );
            m.show();
        }
    }
}
